import { Polling } from 'components/common';
import { useDropsContext } from 'components/Drops/DropsContext';
import groupBy from 'lodash/groupBy';
import orderBy from 'lodash/orderBy';
import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { DROP, Original } from 'components/common';
import { fetchExternalCollectionItems } from 'utils/platformPublicApi';
import { getAllOriginals } from 'utils/legacyEbService';
import { futuraContractAddress, platformCollectionIds } from 'utils/config';

const getFuturaMasters = async (): Promise<Original[]> => {
  try {
    const { results } = await fetchExternalCollectionItems(
      platformCollectionIds.futura,
      [{
        name: 'Generation',
        value: '0', 
      }],
      undefined,
    );

    return results.map(item => ({
      id: item.token_id,
      mintNumber: Number(item.token_id),
      owner: '',
      contractAddress: futuraContractAddress,
      attributes: item.attributes,
      media: {
        image: item.media.image?.full || '',
        animatedImage: '',
        animation: '',
        audio: '',
      },
    }));
  } catch (error) {
    console.error(error);
    return [];
  }
}

const useOriginals = () => {
  const { dropConfig, selectedDrop } = useDropsContext();

  let fetchOriginals = getAllOriginals;
  if (selectedDrop === DROP.futura) {
    fetchOriginals = getFuturaMasters;
  }

  const { status, data: all } = useQuery('originals', fetchOriginals, {
    refetchInterval: Polling.slow,
  });

  const originalIds = (all || []).map(a => a.id);

  const defaultSort = useMemo(() => {
    return orderBy(all, 'mintNumber');
  }, [all]);

  const groupedByContract = useMemo(() => {
    return groupBy(defaultSort, 'contractAddress');
  }, [defaultSort]);
  
  const activeDropOriginals = useMemo(() => {
    return groupedByContract[dropConfig.contractAddress];
  }, [groupedByContract, dropConfig]);
  
  return {
    all: all || [],
    genesisEnigma: all ? all.filter(item => item.contractAddress !== futuraContractAddress) : [],
    sorted: defaultSort || [],
    groupedByContract,
    status,
    activeDropOriginals,
    originalIds,
  };
};

export default useOriginals;
